export default __webpack_public_path__ + "static/media/Bedrock_JE2_BE2.f96bd925.png";